<!-- 公共组件--查看短信内容 -->
<template>
  <myPopup :flag="isShow" @close="close">
    <div>
      <div class="mobile-box" :style="{ background: 'url(' + mobileScreen + ') no-repeat' }">
        <div class="sms-center">
          <div class="message-content">
            <!-- 文本内容 -->
            <div>
              <p>【{{cusuffix}}】{{content}}</p>
            </div>
          </div>
        </div>
      </div>
    </div>
  </myPopup>
</template>

<script>
import myPopup from '@/components/myPopupForSms'

import { mediaDetail } from "@/api/smsSend";

export default {
  components: {
    myPopup
  },
  props: {
    isShow: {
      type: Boolean,
      default: false
    },
    // 标题
    cusuffix: {
      type: String,
      default: ''
    },
    // 内容
    content: {
      type: String,
      default: ''
    },

  },
  data() {
    return {
      mobileScreen: require("@/assets/images/mobileScreen.png"), // 预览图地址
    }
  },
  created() {
  },
  mounted() {
  },
  methods: {
    close() {
      this.$emit('close', false);
    },
  }
}
</script>

<style lang="scss" scoped>
.mobile-box {
  position: relative;
  width: 256px;
  height: 504px;

  .sms-center {
    overflow: auto;
    width: 244px;
    height: 335px;
    position: relative;
    top: 93px;
    left: 0;

    &::-webkit-scrollbar {
      display: none;
    }
  }

  .message-content {
    word-wrap: break-word;
    padding: 6px 10px;
    border-radius: 10px;
    display: inline-block;
    max-width: 190px;
    min-width: 97px;
    font-size: 12px;
    background-color: #E5E6EA;
    line-height: 18px;
    margin-left: 15px;
    text-align: left;
    margin-top: 2px;
  }

  .message-content2 {
    max-width: 190px;
    margin-left: 15px;
    margin-top: 2px;
    padding: 0;
    box-sizing: border-box;
    display: flex;
    align-items: center;

    img {
      max-width: 190px;
      border-radius: 6px;
    }
  }

  .message-content3 {
    background-color: #E5E6EA;
    border-radius: 15px;
    max-width: 136px;
    height: 31px;
    margin-left: 15px;
    margin-top: 2px;
    padding: 0;
    box-sizing: border-box;
    display: flex;
    align-items: center;

    >div {
      &:nth-child(1) {
        width: 34px;
        display: flex;
        align-items: center;
        justify-content: center;

        img {
          width: 25px;
          height: 25px;
          cursor: pointer;
        }
      }

      &:nth-child(2) {
        width: 72px;
        display: flex;
        align-items: center;
        padding-left: 4px;

        img {
          width: 28px;
          height: 18px;
        }
      }

      &:nth-child(3) {
        flex: 1;
        color: #ADADAD;
        font-size: 12px;
      }
    }
  }
}
</style>